import { render } from "./NFormItem.vue?vue&type=template&id=9b3cfd84&ts=true"
import script from "./NFormItem.vue?vue&type=script&lang=ts"
export * from "./NFormItem.vue?vue&type=script&lang=ts"

import "./NFormItem.vue?vue&type=style&index=0&id=9b3cfd84&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__